import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { GenericInput } from "../../../Shared/components/GenericInput";
import { GenericLink } from "../../../Shared/components/GenericLink";
import { GenericButton } from "../../../Shared/components/GenericButton";
import { OverlayLoader } from "../../../Shared/components/Overlay";
import { AuthService } from "../services/AuthService";
import { ToastResponse } from "../../../Shared/types/ToastProps";
import { Toast } from "../../../Shared/components/Toast";
import { useTranslation } from "react-i18next";

export const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const {t} = useTranslation()
  const message = t('loading_message');
  const [showToast, setShowToast] = useState(false);
  const [toast, setToast] = useState<ToastResponse>();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const onEmail = (val: string) => {
    setEmail(val);
    setEmailError(val.includes("@") ? "" : "");
  };

  const resetForm = () => {
    setEmail("");
    setEmailError("");
  };

  const isFormValid = email.trim() !== "";

  const forgotPasswordAction = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await AuthService.forgotPassword(email.trim());
      navigate("/auth/reset-password");
      resetForm();
    } catch (error: any) {
      setShowToast(true);
      setToast({ message: `Error ${error?.message}`, type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="relative">
        <div className="w-full h-100">
          <h1 className="text-xl md:text-2xl font-bold leading-tight mt-12">
            {t('forgot_password_title')}
          </h1>

          <form className="mt-6" onSubmit={forgotPasswordAction}>
            <GenericInput
              label={t('email_label')}
              value={email}
              onChange={onEmail}
              type="email"
              error={emailError}
              placeholder={t('email_hint')}
              required={true}
            />

            <GenericButton type="submit" disabled={!isFormValid}>
              {t('submit')}
            </GenericButton>
          </form>

          <div className="my-6 border-gray-300 w-full"></div>

          <p className="mt-8 text-center">
            {t('signup_prompt_3')}{" "}
            <GenericLink to="/auth/register" label={t('signup_prompt_4')} />
          </p>
        </div>
      </div>
      {showToast && (
        <Toast
          type={toast?.type}
          message={toast?.message ?? ""}
          onClose={() => setShowToast(false)}
        />
      )}
      {isLoading && <OverlayLoader message={message} />}
    </>
  );
};
